/** Pazaryeri görsel kimliği: logo (public/marketplaces/*.png) ya da renkli baş harf. */
import React from 'react';
import { T } from './shared';

// Marka renkleri — logosu olmayan pazaryerleri renkli baş harf rozetiyle gösterilir.
export const MARKET_COLORS: Record<string, string> = {
  trendyol: '#F27A1A', hepsiburada: '#FF6000', boyner: '#FE1B35', amazon: '#FF9900', n11: '#6D28D9', ciceksepeti: '#1F4AA8',
  'çiçeksepeti': '#1F4AA8', pazarama: '#5B21B6', pttavm: '#E6B800', 'idefix': '#E30613', shopify: '#5E8E3E',
};
export const marketColor = (name: string) => MARKET_COLORS[(name || '').toLowerCase().replace(/\s+/g, '')] || T.textMid;
// Logosu olan pazaryerleri (public/marketplaces/*.png, 128px kare); olmayanlarda baş harf rozeti.
const MARKET_LOGOS: Record<string, string> = {
  trendyol: '/marketplaces/trendyol.png', hepsiburada: '/marketplaces/hepsiburada.png',
  shopify: '/marketplaces/shopify.png', boyner: '/marketplaces/boyner.png',
};
export const marketLogo = (name: string) => MARKET_LOGOS[(name || '').toLowerCase().replace(/\s+/g, '')];

export function MarketMark({ name, size }: { name: string; size: number }) {
  const logo = marketLogo(name);
  const r = Math.round(size * 0.24);
  if (logo) return <img src={logo} alt="" width={size} height={size}
    style={{ width: size, height: size, borderRadius: r, flexShrink: 0, display: 'block', boxShadow: `0 0 0 1px ${T.border}` }} />;
  return (
    <span style={{ width: size, height: size, borderRadius: r, background: marketColor(name), color: '#fff', display: 'inline-flex', alignItems: 'center',
      justifyContent: 'center', fontSize: Math.round(size * 0.5), fontWeight: 800, flexShrink: 0 }}>{(name || '?').charAt(0).toUpperCase()}</span>
  );
}

